module.exports = __webpack_public_path__ + "static/media/graphQlIcon.e6990cd7.svg";